import { NavLink } from 'react-router-dom';
import { IconHelp } from './icons';
import { NAV_ITEMS, NAV_GROUPS } from '../nav';
import { useAuth } from '../context/AuthContext';

export function Sidebar({ open, onNavigate }: { open: boolean; onNavigate: () => void }) {
  const { canAny, state, logout } = useAuth();

  return (
    <div className={'sidebar' + (open ? ' open' : '')} id="sidebar">
      {NAV_GROUPS.map((group) => {
        const items = NAV_ITEMS.filter((n) => n.group === group && (!n.scopes || canAny(n.scopes)));
        if (!items.length) return null;
        return (
          <div key={group}>
            <div className="navgroup">{group}</div>
            {items.map((n) => (
              <NavLink
                key={n.path}
                to={n.path}
                className={({ isActive }) => 'navitem' + (isActive ? ' active' : '')}
                onClick={onNavigate}
              >
                <n.icon width={17} height={17} />
                <span>{n.label}</span>
              </NavLink>
            ))}
          </div>
        );
      })}
      <NavLink to="guide" className="sidebar-guide-link" onClick={onNavigate}>
        <IconHelp width={16} height={16} />
        <span>Guide utilisateur</span>
      </NavLink>
      <div className="sidebar-footer">
        <div className="who">{state.user} @ {state.tenant}</div>
        <button onClick={logout}>Déconnexion</button>
      </div>
    </div>
  );
}
